import * as React from "react"

// TODO SNSリンクのメンテナンス
export const SnsFb = () => {
  // eslint-disable-next-line jsx-a11y/anchor-has-content,jsx-a11y/anchor-is-valid
  return <a href="#" className="btnSns btnSns--fb" target="_blank"></a>
}

export const SnsTw = () => {
  // eslint-disable-next-line jsx-a11y/anchor-has-content,jsx-a11y/anchor-is-valid
  return <a href="#" className="btnSns btnSns--tw" target="_blank"></a>
}